import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import RechargeMobileForm from '../forms/RechargeMobileForm'
import CustomLink from '../components/CustomLink'
import PaymentInformation from './PaymentInformation'
import ThingsToKnow from './ThingsToKnow'
import { SERVICE_NBN } from '../constants'

const RechargeNow = (props) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [plans, setPlans] = useState([])

    useEffect(() => {
        getPlans()
    }, [props.serviceId])

    const getPlans = () => {
        DataSource.getData(`/api/getMobilePlans/${props.serviceId}`, result => {
            setIsLoaded(true)
            setPlans(result.plans)
        }, error => {
            setIsLoaded(true)
            setHasError(true)
        })
    }

    const handleSuccess = (response, state) => {
        props.updateServiceDetails(false)
    }

    return (
        <div>
            <div className='recharge-mobile-module module' style={{ overflow: 'visible' }}>
                <div id='sub-navigation' />{/* This is for scrollToNav method in FormHOC */}
                <Heading title='Manage recharge' />
                <ModuleWithLoader isLoaded={isLoaded} hasError={hasError} className='p-4'>
                    <div className='row mb-4'>
                        <div className='col-12 col-lg-10 offset-lg-1 text-center'>
                            <p className='m-0 lh'>Your ExeSIM mobile pre-paid service comes with Auto-recharge as default. This means that at the end of each 30-day usage cycle your usage allowances are automatically renewed and charged for the next 30 days. If you change your Auto-recharge plan here, your new plan and usage cycle will take effect immediately and any unused data on your current cycle will be added to your Data Bank. You can also opt-in to have your account Auto-recharged whenever your data runs out during your usage cycle - <CustomLink to={`/my-services/mobile/${props.serviceId}/zero-data-recharge`}>learn more.</CustomLink></p>
                        </div>
                    </div>
                    <RechargeMobileForm
                        serviceId={props.serviceId}
                        autoRechargeZeroData={props.serviceDetails.autoRechargeZeroData}
                        plans={plans}
                        existingPlanId={props.serviceDetails.planId}
                        handleSuccess={handleSuccess}
                    />
                </ModuleWithLoader>
            </div>
            <PaymentInformation />
            <ThingsToKnow type='migrateMobile' />
        </div>
    )
}

RechargeNow.propTypes = {
    serviceId: PropTypes.number.isRequired,
    serviceDetails: PropTypes.object.isRequired,
    updateServiceDetails: PropTypes.func.isRequired
}

export default RechargeNow



// WEBPACK FOOTER //
// ./resources/js/modules/RechargeNow.js